import { useTranslation } from "react-i18next"
import { useGetSpeciesQuery } from "@/features/farm/api/species-api.ts"
import { useGetAnimalsCountMap } from "@/features/home/hooks/use-get-animals-count-map.ts"
import { FARM_TYPE } from "@/features/settings-account/utils/initialStates.ts"

export const useGetAnimalsCountString = () => {
  const { t } = useTranslation()
  const { data: species_breeds = {} } = useGetSpeciesQuery()
  const animalCountMap: { [key: string]: number } = useGetAnimalsCountMap()

  const getStringForSingle = (permission: FARM_TYPE) => {
    switch (permission) {
      case FARM_TYPE.COW:
        return t("Cow")
      case FARM_TYPE.SHEEP:
        return t("singleSheep")
      case FARM_TYPE.PORK:
        return t("singlePork")
      case FARM_TYPE.GOAT:
        return t("singleGoat")
    }
  }

  const getStringForMultiple = (permission: FARM_TYPE) => {
    switch (permission) {
      case FARM_TYPE.COW:
        return t("Cows")
      case FARM_TYPE.SHEEP:
        return t("Sheep")
      case FARM_TYPE.PORK:
        return t("Pork")
      case FARM_TYPE.GOAT:
        return t("Goat")
    }
  }

  const getSpeciesNameByCount = (farmType: FARM_TYPE, count: number) => {
    let species
    if (count > 1) {
      species = getStringForMultiple(farmType)
    } else if (count == 1) {
      species = getStringForSingle(farmType)
    }
    return species
  }

  const countStrings: (string | null)[] = Object.values(species_breeds || {})
    .map((species) => {
      const count: number = animalCountMap[species.name] || 0
      if (count > 0) {
        const speciesName = getSpeciesNameByCount(
          species.name as FARM_TYPE,
          count,
        )
        return speciesName ? `${count} ${speciesName}` : null
      }
      return null
    })
    .filter(Boolean)

  const animalsCountString = countStrings.join(", ")

  return { animalsCountString, animalCountMap }
}
